import { assign, createMachine, Interpreter, StateSchema } from 'xstate-v4'
import { SignUpErrors, SignUpUserData } from './types'

export type SignUpEvent = { type: 'SIGN_UP'; data: SignUpUserData }

interface SignUpContext {
  validationErrors: SignUpErrors
  successMessage?: string
  authenticated?: boolean
  redirectUrl?: string
}

export function returnSignUpMachine() {
  return createMachine<SignUpContext, SignUpEvent>(
    {
      context: {
        validationErrors: {},
        successMessage: undefined,
      },
      initial: 'idle',
      states: {
        idle: {
          initial: 'normal',
          on: {
            SIGN_UP: {
              target: 'submitting',
              actions: assign({
                validationErrors: (_) => ({}),
              }),
            },
          },
          states: {
            normal: {
              onEntry: assign({
                validationErrors: (_) => ({}),
              }),
            },
            errors: {
              entry: assign({
                validationErrors: (_, { data }: any) =>
                  data.validationErrors || {},
              }),
            },
          },
        },
        submitting: {
          invoke: {
            src: 'createUser',
            onDone: {
              target: 'created',
              actions: assign({
                successMessage: (_, event: any) => event.data.message,
                authenticated: (_, event: any) => event.data.authenticated,
                redirectUrl: (_, event: any) => event.data.redirect_url,
              }),
            },
            onError: [
              {
                target: 'idle.errors',
                cond: (_, { data }: any) => !!data.validationErrors,
              },
              {
                target: 'idle.errors',
                actions: 'logError',
              },
            ],
          },
        },
        created: {
          type: 'final',
        },
      },
    },
    {
      actions: {
        logError: () => {
          throw new Error('signUpMachine.logError not implemented')
        },
      },
      services: {
        createUser: () => {
          throw new Error('signUpMachine.createUser not implemented')
        },
      },
    },
  )
}

export type SignUpMachineInterpreter = Interpreter<
  SignUpContext,
  StateSchema,
  SignUpEvent
>
